//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import userChecks from '~/mixins/userChecks';
export default {
  mixins: [userChecks],
  async fetch() {
    let query = {
      slug: this.$route.params.slug,
      query: this.queries.model
    };
    await Promise.all([ 
     this.$store.dispatch('resourcesStore/getResource', query),
     this.$store.dispatch('bannerStore/getBanner', 'resource'),
     this.$store.dispatch('resourcesStore/countResource', {
      id: this.$route.params.slug
    })
   ])
  },
  head() {
    return {
      title:
      this.model && this.model.seo && this.model.seo
      ? this.model.seo.title
      : this.$seo.modellen.title + ' | ' + process.env.APP_TITLE,
      meta: [
        {
          hid: 'title',
          name: 'title',
          content:
          this.model && this.model.seo && this.model.seo
          ? this.model.seo.title
          : this.$seo.modellen.title + ' | ' + process.env.APP_TITLE,
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content:
          this.model && this.model.seo && this.model.seo
          ? this.model.seo.title
          : this.$seo.modellen.title + ' | ' + process.env.APP_TITLE,
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content:
          this.model && this.model.seo && this.model.seo
          ? this.model.seo.title
          : this.$seo.modellen.title + ' | ' + process.env.APP_TITLE,
        },
        {
          hid: 'description',
          name: 'description',
          content:
          this.model && this.model.seo && this.model.seo
          ? this.model.seo.description
          : 'Geil model van ' +
          process.env.APP_TITLE +
          ' en al de lekkere sexfilms',
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content:
          this.model && this.model.seo && this.model.seo
          ? this.model.seo.description
          : 'Geil model van ' +
          process.env.APP_TITLE +
          ' en al de lekkere sexfilms',
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content:
          this.model && this.model.seo && this.model.seo
          ? this.model.seo.description
          : 'Geil model van ' +
          process.env.APP_TITLE +
          ' en al de lekkere sexfilms',
        },
        {
          hid: 'og:url',
          name: 'og:url',
          content:
          this.model && this.model.slug
          ? process.env.FE_URL +
          '/' +
          this.$seo.modellen.slug +
          '/' +
          this.model.slug
          : process.env.FE_URL + '/' + this.$seo.modellen.slug + '/',
        },
        {
          hid: 'twitter:url',
          name: 'twitter:url',
          content:
          this.model && this.model.slug
          ? process.env.FE_URL +
          '/' +
          this.$seo.modellen.slug +
          '/' +
          this.model.slug
          : process.env.FE_URL + '/' + this.$seo.modellen.slug + '/',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content:
          this.model && this.model.seo && this.model.seo
          ? this.model.seo.keywords
          : 'Model, sexmodel, pornoster',
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content:
          this.model && this.model.thumb
          ? process.env.CDN + this.model.thumb.l
          : '',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content:
          this.model && this.model.thumb
          ? process.env.CDN + this.model.thumb.l
          : '',
        },
        {
          hid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary_large_image',
        },
      ],
    };
  },
  components: {
    dummy: () => import('~/components/content/dummy/resource_dummy.vue'),
    breadcrumbs: () => import('~/components/breadcrumbs'),
    Description: () => import('~/components/DescriptionResources.vue'),
    Readmore: () => import('~/components/Readmore.vue'),
    favorite: () => import('~/components/FavoriteResources'),
    IncludedVideos: () => import('~/components/IncludedVideos.vue'),
    banner: () => import('~/components/banner.vue'),
    error: () => import('~/components/error.vue'),
  },
  computed: {
    ...mapState({
      queries: ({ resourcesStore: {queries} }) => queries,
      model: ({ resourcesStore: {model} }) => model,
      modal: ({ modalStore: {modal} }) => modal,
      loading: ({ resourcesStore: {loading} }) => loading
    }),
  },
  data() {
    return {
      pasen: false
    };
  },
  methods: {
    toggleModal(type) {
      if (!this.$auth.loggedIn && type == 'favorite') {
        var alertObj = {};
        alertObj.type = 'info';
        alertObj.message = 'Je kan alleen favorieten toevoegen als je bent ingelogd.';
        return this.$store.commit('alertStore/setAlert', alertObj);  
      }
      if (!this.$auth.loggedIn && type == 'pasen') {
        var alertObj = {};
        alertObj.type = 'info';
        alertObj.message = 'Wow! Je hebt het paaseitje gevonden... Je moet alleen nog even inloggen of registreren om je prijs te zien.';
        return this.$store.commit('alertStore/setAlert', alertObj);  
      }
      this.$store.commit('modalStore/setModal', type)
    },
  },
};
